/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
	data() {
		return {
			posts: [],
			loaded: false,
			pageTitle: 'Blog',
		};
	},
	created() {
		this.fetchPosts();
	},
	methods: {
		fetchPosts() {
			const vm = this;

			fetch( ui_data.homeUrl + '/wp-json/wp/v2/posts?per_page=100&_embed=1' )
				.then( function ( response ) {
					return response.json();
				} )
				.then( function ( posts ) {
					vm.posts = posts;
					vm.loaded = true;
				} )
				.catch( function () {
					vm.loaded = true;
				} );
		},
		postPath( post ) {
			try {
				return new URL( post.link ).pathname;
			} catch ( error ) {
				return post.link;
			}
		},
		postImage( post ) {
			const media = post._embedded && post._embedded['wp:featuredmedia'];

			if ( media && media[0] && media[0].source_url ) {
				return media[0].source_url;
			}

			return '';
		},
		formatDate( date ) {
			return new Date( date ).toLocaleDateString( 'en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			} );
		},
	},
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-outer"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))])]),_vm._v(" "),(_vm.posts.length)?_c('ul',{staticClass:"blog-wrapper"},_vm._l((_vm.posts),function(post){return _c('li',{key:post.id,staticClass:"post-card grid-third"},[_c('router-link',{staticClass:"post-card__link",attrs:{"to":_vm.postPath( post )}},[(_vm.postImage( post ))?_c('figure',[_c('img',{staticClass:"post-card__image",attrs:{"src":_vm.postImage( post ),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"post-card__content"},[_c('h2',{staticClass:"post-card__title",domProps:{"innerHTML":_vm._s(post.title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"post-card__excerpt",domProps:{"innerHTML":_vm._s(post.excerpt.rendered)}}),_vm._v(" "),_c('div',{staticClass:"post-card__meta"},[_c('div',{staticClass:"post-card__date"},[_c('time',{attrs:{"datetime":post.date}},[_vm._v(_vm._s(_vm.formatDate( post.date )))])])])])])],1)}),0):(_vm.loaded)?_c('div',{staticClass:"container"},[_c('p',[_vm._v("No posts found.")])]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BlogPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__